var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('h2',[_vm._v("AGV "+_vm._s(_vm.agvName)+" Profile Information")]),_c('agv-tabs',{attrs:{"agv-name":_vm.agvName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }